import { render, staticRenderFns } from "./AreaClip.vue?vue&type=template&id=46e21adc&scoped=true"
import script from "./AreaClip.vue?vue&type=script&lang=js"
export * from "./AreaClip.vue?vue&type=script&lang=js"
import style0 from "./AreaClip.vue?vue&type=style&index=0&id=46e21adc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e21adc",
  null
  
)

export default component.exports